<template>
  <el-breadcrumb separator-class="el-icon-arrow-right shadow_box" id="breadcrumb">
    <div style="float:left; width:70px; height:40px; line-height:40px;">当前位置：</div>
    <el-breadcrumb-item v-for="(e, i) in breadList" :key="i" :to="{name:e.name}">{{
      e.meta.title
    }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  data() {
    return {
      breadList: [], // 路由集合
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    isHome(route) {
      // 检测路由是否是指向Home
      return route.name === "Home";
    },
    getBreadcrumb() {
      let matched = this.$route.matched;
      // 如果第一个路由不是首页，则加上首页,用concat进行数组连接，如果用push或splice则会对原数组改变，其他链接便不能复用了
      if (!this.isHome(matched[0])) {
        matched = [{ name: "Home", meta: { title: "首页" } }].concat(matched);
      }
      // 因为router-view层级在初始状态已经是第二级（默认#app是顶级，layout二级），所以删掉一级多余的路由元素
      matched.splice(1,1);
      // 如果二级路由直接指向Home，就去掉重复的Home面包屑
      if(matched[1].name==='Home'){
        matched.pop();
      }
      // 输出面包屑路由器
      this.breadList = matched;
    },
  },
  created() {
    this.getBreadcrumb();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue